<template>
  <div>
    <form-request
      :action="src"
      v-slot="{ submit, updateForm }"
    >
      <div class="hamcat" />
      <template v-if="vapor.enabled">
        <media-library-collection
          :name="collectionName"
          :initial-value="files"
          @is-ready-to-submit-change="mediaReady = $event"
          :validation-errors="errors"
          @change="onMediaAttached($event, updateForm)"
          :sortable="sortable"
          vapor
        />
      </template>

      <template v-else>
        <media-library-collection
          :name="collectionName"
          :initial-value="files"
          @is-ready-to-submit-change="mediaReady = $event"
          :validation-errors="errors"
          @change="onMediaAttached($event, updateForm)"
          :sortable="sortable"
        />
      </template>

      <button
        @click="submit()"
        :disabled="!mediaReady"
        class="btn btn-primary mt-4"
      >
        Submit
      </button>
    </form-request>
  </div>
</template>

<script>
import { MediaLibraryAttachment } from 'media-library-pro-vue3-attachment'
import { MediaLibraryCollection } from 'media-library-pro-vue3-collection'
import FormRequest from '@/Components/Forms/FormRequest'

export default {
  components: { MediaLibraryAttachment, MediaLibraryCollection, FormRequest },

  props: {
    /**
     * Initial files to show
     */
    files: {
      type: Array,
      default() {
        return []
      }
    },

    /**
     * The route we upload the file to
     */
    src: {
      type: String,
      required: true
    },

    /**
     * The name of the media collection
     */
    collectionName: {
      type: String,
      required: false,
      default: 'media'
    },

    /**
     * The key name to upload media to
     */
    uploadKey: {
      type: String,
      required: false,
      default: 'media'
    },

    /**
     * List of validation errors from server
     */
    errors: {
      type: Object,
      default() {
        return {}
      }
    },

    /**
     * Configuration variables for laravel vapor
     */
    vapor: {
      type: Object,
      default() {
        return { enabled: false }
      }
    },

    /**
     * Is the collection sortable
     */
    sortable: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      mediaReady: false
    }
  },

  methods: {
    /**
     * Called when a new file is dragged into the uploader box or selected with file selector
     * @param files a list of files that have been attached
     * @param updateForm a function to call to update the form
     */
    onMediaAttached(files, updateForm) {
      updateForm({ [this.uploadKey]: files })
    }
  }
}
</script>
